import { Checkbox } from '@rmwc/checkbox';
import React, { SyntheticEvent, KeyboardEvent } from 'react';
import '@rmwc/checkbox/styles';
import { useTranslation } from 'react-i18next';
import styles from './CheckBox.module.scss';
import LinkButton from './LinkButton';

type Props = {
    checked: boolean;
    id: string;
    label: string;
    link?: string;
    linkText?: string;
    onChange: (e: SyntheticEvent<HTMLElement> | KeyboardEvent<HTMLElement>) => void;
    invalid?: boolean;
    helpText?: string;
    testAttr: string;
};

const CheckBox = ({
    checked,
    id,
    onChange,
    label,
    link,
    linkText,
    helpText,
    invalid,
    testAttr,
}: Props): JSX.Element => {
    const { t: txt } = useTranslation();
    const onClick = (e: SyntheticEvent<HTMLElement>): void => {
        onChange(e);
    };

    const onKeyDown = (e: KeyboardEvent<HTMLElement>): void => {
        if (e.key === 'Enter') {
            e.stopPropagation();
            e.preventDefault();
            onChange(e);
        }
    };
    const labelElement =
        link && linkText ? (
            <span>
                {txt(label)}
                {link && linkText && <LinkButton link={link} label={linkText} external newPage />}
            </span>
        ) : (
            label
        );

    return (
        <div className={styles.checkBox}>
            <Checkbox
                label={labelElement}
                id={id}
                checked={checked}
                onChange={onClick}
                onKeyDown={onKeyDown}
                {...{ [`data-${testAttr}`]: true }}
            />
            {invalid && helpText && (
                <div data-helptext={true} className={styles.helpText}>
                    {txt(helpText)}
                </div>
            )}
        </div>
    );
};

export default CheckBox;
